import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import ability from '@/components/comPages/ability'
import insurance from '@/components/comPages/insurance'
import afterMarket from '@/components/comPages/afterMarket'
import about from '@/components/comPages/about'
import joinUs from '@/components/comPages/joinUs'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/index',
      name: 'index',
      meta: 1,
      component: index
    },
    {
      path: '/ability',
      name: 'ability',
      meta: 2,
      component: ability
    },
    {
      path: '/insurance',
      name: 'insurance',
      meta: 3,
      component: insurance
    },
    {
      path: '/afterMarket',
      name: 'afterMarket',
      meta: 4,
      component: afterMarket
    },
    {
      path: '/about',
      name: 'about',
      meta: 5,
      component: about
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      meta: 6,
      component: joinUs
    },
    {
      path: '*',
      redirect: '/index'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js